/**
 * BrandLogo — renders the active tenant's logo.
 * Falls back to the S.DRIVE wordmark image when no custom logo is set.
 *
 * Usage:
 *   <BrandLogo className="h-7 w-auto shrink-0" />
 */

import React from "react";
import { useBranding } from "@/contexts/BrandingContext";

export default function BrandLogo({ className = "h-7 w-auto shrink-0", showName = false }) {
  const { logoUrl, companyName, isDefault } = useBranding();
  return (
    <div className="flex items-center gap-2 min-w-0" data-testid="brand-logo">
      <img
        src={logoUrl}
        alt={companyName}
        className={className}
        // Hide a broken custom logo gracefully — the company name keeps the
        // tenant identity visible.
        onError={(e) => { e.currentTarget.style.display = "none"; }}
      />
      {(showName || isDefault === false) && (
        <span
          className="text-sm sm:text-base font-semibold text-white truncate"
          data-testid="brand-company-name"
        >
          {companyName}
        </span>
      )}
    </div>
  );
}
